import { useState } from 'react';
import { useAuthContext } from './useAuthContext';

export const useSignup = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { dispatch } = useAuthContext();

    const signup = async (data) => {
        setIsLoading(true);
        setError(null);

        try {
            // Note: Update to use REACT_APP_API_URL or environment variable proxy where viable
            const response = await fetch('/api/auth/signup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            const json = await response.json();

            if (!response.ok) {
                setError(json.error);
                setIsLoading(false);
                return { success: false, error: json.error };
            }

            // Save the user to local storage and update context
            localStorage.setItem('user', JSON.stringify(json));
            dispatch({ type: 'LOGIN', payload: json });

            setIsLoading(false);
            return { success: true };
        } catch (error) {
            setError('An unexpected error occurred during signup.');
            setIsLoading(false);
            return { success: false, error: 'Network error.' };
        }
    };

    return { signup, isLoading, error };
};